<ion-header collapse="fade" translucent="true">
  <ion-toolbar>
    <ion-title>{{ "ORDERS.CREATE_ORDER" | translate }}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/main/orders" />
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="scroll-visible">
  <div class="flex justify-center">
    <div class="h-full w-full max-w-[1200px] p-4">
      <!-- Selected Items Summary -->
      @if (store.selectedItems().length > 0) {
        <ion-card class="mb-4 p-4">
          <div class="flex items-center justify-between mb-2">
            <ion-text class="text-lg font-bold">{{ "ORDERS.SELECTED_ITEMS" | translate }}</ion-text>
            <ion-text color="primary" class="text-xl font-bold">{{ store.total() | vxCurrency }}</ion-text>
          </div>
          <div class="bg-light h-[1px] w-full my-2"></div>

          @for (item of store.selectedItems(); track $index) {
            <div class="flex items-center mb-3">
              <mtjr-img
                [src]="item.product.images?.[0]"
                [imgClass]="'w-16 aspect-square rounded-lg object-cover me-3'"
                [blurHash]="item.product.blurHash"
                alt="{{ 'PRODUCTS.PRODUCT_IMAGE' | translate }}"
              />
              <div class="flex-1">
                <ion-text class="font-medium">{{ item.product.name }}</ion-text>
                <div class="flex items-center mt-1">
                  <ion-text color="medium" class="text-sm me-2">
                    {{ item.variation ? getVariationLabel(item.variation) : "" }}
                  </ion-text>
                  <ion-text color="primary" class="font-bold">{{ item.finalPrice | vxCurrency }}</ion-text>
                </div>
              </div>
              <div class="flex items-center">
                <ion-button
                  size="small"
                  fill="clear"
                  (click)="store.updateQuantity(item.product.id, item.variation?.id, item.quantity - 1)"
                >
                  <ion-icon slot="icon-only" name="remove-circle-outline"></ion-icon>
                </ion-button>
                <ion-text class="mx-2 font-bold">{{ item.quantity }}</ion-text>
                <ion-button
                  size="small"
                  fill="clear"
                  (click)="store.updateQuantity(item.product.id, item.variation?.id, item.quantity + 1)"
                  [disabled]="item.quantity >= (item.variation?.stock ?? item.product.stock ?? 0)"
                >
                  <ion-icon slot="icon-only" name="add-circle-outline"></ion-icon>
                </ion-button>
                <ion-button
                  size="small"
                  fill="clear"
                  color="danger"
                  (click)="store.removeItem(item.product.id, item.variation?.id)"
                >
                  <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                </ion-button>
              </div>
            </div>
          }

          <div class="bg-light h-[1px] w-full my-3"></div>

          <!-- Notes -->
          <div class="mb-3">
            <ion-item lines="none">
              <ion-textarea
                [label]="'ORDERS.NOTES' | translate"
                labelPlacement="floating"
                [value]="store.notes()"
                (ionInput)="store.setNotes($any($event.target).value)"
                [placeholder]="'ORDERS.NOTES_PLACEHOLDER' | translate"
                [rows]="3"
              />
            </ion-item>
          </div>

          <!-- Payment Method -->
          <!-- <div class="mb-3">
            <ion-text class="font-bold mb-2 block">{{ "ORDERS.PAYMENT_METHOD" | translate }}</ion-text>
            <ion-radio-group [value]="store.paymentMethod()" (ionChange)="store.setPaymentMethod($event.detail.value)">
              @for (method of paymentMethods; track $index) {
                <ion-item lines="none">
                  <ion-radio [value]="method">
                    <div class="flex items-center">
                      <ion-icon [name]="method" class="me-2"></ion-icon>
                      <ion-label>{{ "ENUMS.PaymentMethod." + method | translate }}</ion-label>
                    </div>
                  </ion-radio>
                </ion-item>
              }
            </ion-radio-group>
          </div> -->

          <mtjr-error-bar [failure]="store.placeOrderFailure()" />

          <mtjr-submit-button
            [state]="store.placeOrderState()"
            (click)="submitOrder()"
            [expand]="'block'"
            [class]="'mt-3'"
            [label]="
              ('ORDERS.CREATE_ORDER' | translate) + ' (' + store.itemCount() + ' ' + ('COMMON.ITEMS' | translate) + ')'
            "
          />
        </ion-card>
      } @else {
        <div class="flex h-full w-full flex-col items-center justify-center">
          <mtjr-dynamic-img
            src="/assets/no_orders.svg"
            darkSrc="/assets/no_orders_dark.svg"
            class="size-[220px] opacity-80 dark:opacity-70"
          />
          <p class="text-medium/70 mt-2 text-center">{{ "ORDERS.NO_PRODUCTS_SELECTED" | translate }}</p>
        </div>
      }
    </div>
  </div>
</ion-content>
